import PointTileModel from '../../tile/models/tileModel';
import EarthExtrudeModel from './earthExtrude';
import EarthFillModel from './earthFill';
import ExtrudeModel from './extrude';
import FillModel from './fill';
import FillImageModel from './fillmage';
import IconModel from './icon-font';
import IMageModel from './image';
import NormalModel from './normal';
import Radar from './radar';
import SimplePopint from './simplePoint';
import TextModel from './text';
import TileFillModel from './tile';
var PointModels = {
  fillImage: FillImageModel,
  fill: FillModel,
  radar: Radar,
  image: IMageModel,
  normal: NormalModel,
  simplePoint: SimplePopint,
  extrude: ExtrudeModel,
  text: TextModel,
  icon: IconModel,
  vectorpoint: PointTileModel,
  tile: TileFillModel,
  earthFill: EarthFillModel,
  earthExtrude: EarthExtrudeModel
};
export default PointModels;
//# sourceMappingURL=index.js.map